<template>
	<div class="banner-chooser">
		<div class="row centered">
			<AppRadioButtonGroup :selected="bannerType" :title="getString('banner_mode')" :values="[getString('preset'), getString('customized')]" @radio-chosen="(index) => bannerTypeRadioChanged(index)" />
		</div>
		<AppDropdown :collapsed="bannerType !== 0">
			<div class="row space-between preset-option">
				<div class="image-container" :class="{activePreset: (activePreset === presetImage.number || (userStore.currBusiness && userStore.currBusiness.picture === imageUrl+presetImage.name))}" v-for="presetImage in presetImages" :key="presetImage.number"><img :src="imageUrl+presetImage.name" :alt="presetImage.alt" @click="clickedPreset(presetImage)"></div>
			</div>
		</AppDropdown>
		<AppDropdown :collapsed="bannerType !== 1">
			<div class="row centered custom-option">
				<AppDropzone
					:max-bytes="400 * 1024"
					:max-width="1024"
					:max-height="1024"
					:files="files"
					@upload-complete="(files) => $emit('banner-chosen', files[0])"
					@removed-file="$emit('banner-chosen', null)" />
			</div>
		</AppDropdown>
	</div>
</template>

<script>
import AppSortableList from "@/shared/components/AppSortableList.vue";
import AppRadioButtonGroup from "@/shared/components/AppRadioButtonGroup.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import AppChecklist from "@/shared/components/AppChecklist.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppDropzone from "@/shared/components/AppDropzone.vue";

import {useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		return {
			getString: languageStore.getString,
			userStore,
		};
	},
	name: "BannerChooser",
	emits: ["banner-chosen"],
	components: {
		AppSortableList,
		AppRadioButtonGroup,
		AppDropdown,
		AppChecklist,
		AppTextInput,
		AppButton,
		AppDropzone
	},
	data() {
		return {
			bannerType: 0,
			activePreset: null,
			files: [],
			imageUrl: "https://img.qromo.io/img/presets/",
			imagesForType: {
				"restaurant": [{name: 'new-preset-restaurant-1.jpg', alt: '', number: 1}, {
					name: 'new-preset-restaurant-2.jpg',
					alt: '',
					number: 2
				}, {name: 'new-preset-restaurant-3.jpg', alt: '', number: 3}, {
					name: 'new-preset-restaurant-4.jpg',
					alt: '',
					number: 4
				}, {name: 'new-preset-restaurant-5.jpg', alt: '', number: 5}, {
					name: 'new-preset-restaurant-6.jpg',
					alt: '',
					number: 6
				}, {name: 'new-preset-restaurant-7.jpg', alt: '', number: 7}, {
					name: 'new-preset-restaurant-8.jpg',
					alt: '',
					number: 8
				}, {name: 'new-preset-restaurant-9.jpg', alt: '', number: 9}, {
					name: 'new-preset-restaurant-10.jpg',
					alt: '',
					number: 10
				}, {name: 'new-preset-restaurant-11.jpg', alt: '', number: 11}, {name: 'new-preset-restaurant-12.jpg', alt: '', number: 12}],
				"bar": [{name: 'new-preset-bar-1.jpg', alt: '', number: 1}, {
					name: 'new-preset-bar-2.jpg',
					alt: '',
					number: 2
				}, {name: 'new-preset-bar-3.jpg', alt: '', number: 3}, {
					name: 'new-preset-bar-4.jpg',
					alt: '',
					number: 4
				}, {name: 'new-preset-bar-5.jpg', alt: '', number: 5}, {
					name: 'new-preset-bar-6.jpg',
					alt: '',
					number: 6
				}, {name: 'new-preset-bar-7.jpg', alt: '', number: 7}, {
					name: 'new-preset-bar-8.jpg',
					alt: '',
					number: 8
				}, {name: 'new-preset-bar-9.jpg', alt: '', number: 9}, {
					name: 'new-preset-bar-10.jpg',
					alt: '',
					number: 10
				}, {name: 'new-preset-bar-11.jpg', alt: '', number: 11}, {name: 'new-preset-bar-12.jpg', alt: '', number: 12}],
				"events": [{name: 'new-preset-bar-1.jpg', alt: '', number: 1}, {
					name: 'new-preset-bar-2.jpg',
					alt: '',
					number: 2
				}, {name: 'new-preset-bar-3.jpg', alt: '', number: 3}, {
					name: 'new-preset-bar-4.jpg',
					alt: '',
					number: 4
				}, {name: 'new-preset-bar-5.jpg', alt: '', number: 5}, {
					name: 'new-preset-bar-6.jpg',
					alt: '',
					number: 6
				}, {name: 'new-preset-bar-7.jpg', alt: '', number: 7}, {
					name: 'new-preset-bar-8.jpg',
					alt: '',
					number: 8
				}, {name: 'new-preset-bar-9.jpg', alt: '', number: 9}, {
					name: 'new-preset-bar-10.jpg',
					alt: '',
					number: 10
				}, {name: 'new-preset-bar-11.jpg', alt: '', number: 11}, {name: 'new-preset-bar-12.jpg', alt: '', number: 12}],
				"beach": [{name: 'new-preset-beach-1.jpg', alt: '', number: 1}, {
					name: 'new-preset-beach-2.jpg',
					alt: '',
					number: 2
				}, {name: 'new-preset-beach-3.jpg', alt: '', number: 3}, {
					name: 'new-preset-beach-4.jpg',
					alt: '',
					number: 4
				}, {name: 'new-preset-beach-5.jpg', alt: '', number: 5}, {
					name: 'new-preset-beach-6.jpg',
					alt: '',
					number: 6
				}, {name: 'new-preset-beach-7.jpg', alt: '', number: 7}, {
					name: 'new-preset-beach-8.jpg',
					alt: '',
					number: 8
				}, {name: 'new-preset-beach-9.jpg', alt: '', number: 9}, {
					name: 'new-preset-beach-10.jpg',
					alt: '',
					number: 10
				}, {name: 'new-preset-beach-11.jpg', alt: '', number: 11}, {name: 'new-preset-beach-12.jpg', alt: '', number: 12}],
				"other": [{name: 'new-preset-other-1.jpg', alt: '', number: 1}, {
					name: 'new-preset-other-2.jpg',
					alt: '',
					number: 2
				}, {name: 'new-preset-other-3.jpg', alt: '', number: 3}, {
					name: 'new-preset-other-4.jpg',
					alt: '',
					number: 4
				}, {name: 'new-preset-other-5.jpg', alt: '', number: 5}, {
					name: 'new-preset-other-6.jpg',
					alt: '',
					number: 6
				}, {name: 'new-preset-other-7.jpg', alt: '', number: 7}, {
					name: 'new-preset-other-8.jpg',
					alt: '',
					number: 8
				}, {name: 'new-preset-other-9.jpg', alt: '', number: 9}, {
					name: 'new-preset-other-10.jpg',
					alt: '',
					number: 10
				}, {name: 'new-preset-other-11.jpg', alt: '', number: 11}, {name: 'new-preset-other-12.jpg', alt: '', number: 12}]
			},
		}
	},
	computed: {
		presetImages() {
			if(this.userStore.currBusiness) {
				return this.imagesForType[this.userStore.currBusiness.type];
			} else {
				return [];
			}
		}
	},
	methods: {
		bannerTypeRadioChanged(index) {
			this.bannerType = index;
		},
		clickedPreset(preset) {
			if(this.activePreset === preset.number) {
				this.activePreset = null;
				this.$emit("banner-chosen", null);
			} else {
				this.activePreset = preset.number;
				this.$emit("banner-chosen", this.imageUrl + preset.name);
			}
		},
		selectPresetFromExisting() {
			if(this.userStore.currBusiness && this.userStore.currBusiness.picture) {
				let self = this;
				let found = false;
				this.presetImages.forEach(preset => {
					if(self.imageUrl + preset.name === self.userStore.currBusiness.picture) {
						self.activePreset = preset.number;
						found = true;
					}
				});
				if(!found) {
					this.activePreset = null;
					this.bannerType = 1;
					this.files = [this.userStore.currBusiness.picture];
				}
			}
		},
 	},
	mounted() {
		this.selectPresetFromExisting();
	},
	watch: {
		"userStore.currBusinessId": function() {
			this.selectPresetFromExisting();
		}
	}
}
</script>

<style lang="scss" scoped>

.banner-chooser {

	.preset-option {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;

		.image-container {
			width: 100%;
			max-width: 300px;
			padding: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;

			@media (max-width: 920px) {
				max-width: 270px;
				padding: 15px;
			}

			@media (max-width: 650px) {
				max-width: 200px;
				padding: 10px;
			}

			&::after {
				content: "";
				position: absolute;
				top: 10px;
				left: 10px;
				width: calc(100% - 20px);
				height: calc(100% - 20px);
				border-radius: 13px;
				opacity: 0;
				transition: opacity 0.2s ease-in-out;
				pointer-events: none;
				transform: scale(0.92);
				box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.19);
				background-color: rgba(35, 82, 162, 0.12);
			}

			img {
				width: 100%;
				height: auto;
				border-radius: 13px;
				cursor: pointer;
				transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;
				box-shadow: 0 1px 2px $alpha_4;
			}

			&.activePreset {

				img {
					box-shadow: 0 0 1px $alpha_4;
					transform: scale(0.88);
				}

				&::after {
					opacity: 1;
				}
			}
		}
	}

	.link-option {
		display: flex;
		justify-content: center;
		width: 100%;

		@media (max-width: 500px) {

			.input-wrapper {
				width: 100%;
			}
		}
	}

}
</style>